import React from 'react';
import './Argomenti.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Intro from './Intro';
import Parametri from './Parametri';
import Dispatcher from './Dispatcher';
import Moduli from './Moduli';
import Async from './Async';
import Express from './Express';
import Template from './Template';
import Contenuti from './Contenuti';


const Argomenti = () => {

  const back_to_top =()=> {
	const topElement = document.documentElement;
		topElement.scrollIntoView({
			behavior: 'smooth'
	})
  }

  return (
    <div className="container container-arg">
		<button class="back_to_top" onClick={back_to_top}>&#8593;</button>
		<Contenuti />
		<div id="introduzione"></div>
		<br />
		<hr className="classic-hr"/>
		<br />
    	<Intro id="introduzione"/>
		<div id="parametri"></div>
		<br />
		<hr className="classic-hr"/>
		<br />
		<Parametri />
		<div id="dispatcher"></div>
		<br />
		<hr className="classic-hr"/>
		<br />
		<Dispatcher />
		<div id="moduli"></div>
		<br />
		<hr className="classic-hr"/>
		<br />
		<Moduli />
		<div id="async"></div>
		<br />
		<hr className="classic-hr"/>
		<br />
		<Async />
		<div id="express"></div>
		<br />
		<hr className="classic-hr"/>
		<br />
		<Express />
		<div id="template-engine"></div>
		<br />
		<hr className="classic-hr"/>
		<br />
		<Template />
    </div>
  );
};

export default Argomenti;
